import { Reducer } from 'redux'
import { AddressState, AddressActionTypes } from './type'

const initialState: AddressState = {
  list: [],
  edit: {}
}

const reducer: Reducer<AddressState> = (state = initialState, action) => {
  switch (action.type) {
    case AddressActionTypes.FETCH_ADDRESS_LIST_SUCCESS: {
      const { data } = action;
      return {
        ...state,
        list: data
      }
    }
    case AddressActionTypes.EDIT_ADDRESS: {
      const { key, value } = action;
      return {
        ...state,
        edit: {
          ...state.edit,
          [`${key}`]: value
        }
      }
    }
    case AddressActionTypes.SAVE_ADDRESS_SUCCESS: {
      return {
        ...state,
        edit: {}
      }
    }
    case AddressActionTypes.MODIFY_ADDRESS: {
      const { options } = action;
      return {
        ...state,
        edit: options
      }
    }
    case AddressActionTypes.CLEAR_ADDRESS: {
      return {
        ...state,
        edit: {}
      }
    }
    default: {
      return state
    }
  }
}

export { reducer as AddressReducer };